import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/clock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 456c110.5 0 200-89.5 200-200s-89.5-200-200-200-200 89.5-200 200 89.5 200 200 200zM317.8 351.6l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7v-164.2c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8l-18.8 25.9c-3.9 5.3-11.4 6.5-16.8 2.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/clock.js
// module id = 1712
// module chunks = 0